import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Criminal from "../pages/criminal/page";
import CasesPage from "../pages/cases/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/criminal",
    element: <Criminal />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;